export var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["en"] = "en";
    SupportedLanguage["sk"] = "sk";
})(SupportedLanguage || (SupportedLanguage = {}));
export const socketCookieName = 'praxujSocketCookieSession';
export const userSessionCookieName = 'connect.sid';
